export const BASE_URL = "https://testingscripts.vowstays.com/crmapi/"; // test
// export const BASE_URL = "https://www.iyebackend.vowstays.com/crmapi/"; // live
// export const BASE_URL = "http://192.168.1.17/iye_backend/public/crmapi/"; // local

export const URL = {
  LOGIN: "admin/login",
  LOGOUT: "admin/logout",
  DASHBOARD: "dashboard",
  ROLE: "role",
  ADMIN: "admin",
  STATES: "state",
  CITY: "city",
  LOCATION: "location",
  USERS: "users",
  USER: "user",
  FULL_BLOCK: "full-block/list",
  BOOKING_DETAILS: "booking-details",
  REQUEST_PROPERTY: "request/property",
  PROPERTY_STATUS: "property/status/",
  PROPERTY_CREATE: "property/create",
  PROPERTY: "property",
  UPDATE_PROPERTY: "update/property-image",
  BLOCK_PROPERTY: "block-property-full",
  FOOD_PACKAGE: "foodPackage",
  FOOD_PACKAGE_DELETE: "remove/food-menu-item/",
  FOOD_PACKAGE_REMOVE: "remove/food-package/",
  SERVICE_CREATE: "service/create",
  VIEW_PROPERTY_SERVICE: "edit/property/service/",
  EDIT_PROPERTY_SERVICE: "service/update/",
  ADD_PROPERTY_SERVICE: "service/add/",
  LIST_PHASES: "list/phases/",
  SHOW_ROOM: "show/room/",
  BLOCK_VILLA_PHASE: "block-villa-phase",
  ROOM_SERVICE: "room_service",
  ROOM_BOOKING_CREATE: "room_booking/create",
  ROOM_BOOKING_SLOT: "room_booking/slot/",
  ADD_ROOM: "add/room/",
  EDIT_ROOM: "edit/room/",
  EDIT_ROOM: "edit/room/",
  LIST_ROOM: "list/rooms/",
  EDIT_TIME_SLOT: "edit/timeslot/",
  ADD_TIME_SLOT: "add/timeslot/",
  DELETE_ROOM_IMAGE: "room/image/delete/",
  BLOCK_JW_DO: "block-jw-do",
  SHOW_GET_TO_GETHER: "show/gettg/",
  BLOCK_ROOMS: "block-rooms",
  OWNER: "owner",
  PROPERTY_OWNER: "properties/owner/",
  OWNER_TRASACTION: "owner-transactions/",
  BLOCK_LIST: "block/list",
  LIST_PHASE_ROOMS: "list/phase/rooms/",
  BLOCK_VILLA_ROOMS: "block-villa-rooms",
  UNBLOCK_PROPERTY: "unblock-propertybooking",
  UNBLOCK_ROOM: "unblock-roombooking",
  RECEPTIONIST: "receptionist",
  MMC: "mcc",
  RECOMMENDATION: "recommendation",
  SUBSCRIPTION_CANCEL_REQUESTS: "subscription-cancel/requests",
  SUBSCRIPTION_CANCELED: "subscription-cancel/canceled",
  CANCEL_SUBSCRIPTION: "cancel-subscription/",
  PROPERTY_RECOMMENDATIONS: "property/recommendations",
  MCC_PROPERTIES: "mcc/properties",
  SERVICES: "service",
  CATEGORIES: "category",
  TIME_SLOT: "timeslots",
  ROOM_CATEGORY_LIST: "roomc",
  BOOKING: "bookings",
  TODAY_EARNING: "today-earnings",
  CANCELLED_BOOKING: "cancelled-bookings",
  TIPS: "tips",
  TIP: "tip",
  SUPPORT: "support/list/",
  RESOLVE: "resolved/list/",
  SUPPORT_STATUS: "support/status",
  TRANSACTION: "transactions",
  TRANSACTION_DETAILS: "transaction-details/",
  COUPONS: "coupon",
  REFFERALS: "refferals",
  USER_REFFERALS: "user/refferals/",
  BANNER: "banner",
  AMENTITY: "amenity",
  REVIEWS_LIST: "review/list",
  ROOM_SHARIG_REVIEWS_LIST: "room-sharing-reviews/list",
  REVIEW_STATUS: "review/status/",
  REVIEW_VIEW: "review/view/",
  BOOKING_DETAILS_VIEW: "booking-details-view",
  OWNER_PAYMENT_VIEW: "owner-payment-view",
  TRANSACTION_REPORT: "transaction-report",
  OWNER_PAYMENT_IMPORT: "owner-payment-import",
  WISHLIST_PROPERTIES: "wishlist/properties",
  WISHLIST_PROPERTIES_USERS: "wishlist/users/",
};

export const TOKEN = "token";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";

export const NUMBER = /^\+?(0|[6-9]\d*)$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};
